import {Record} from 'immutable';
import { SupportTicketStatus } from './SupportTicketStatus';

const SupportTicketRecord = Record({
	number: null,
	subject: null,
	createdAt: null,
	lastReplyAt: null,
	customerEmail: null,
	rawDeviceIds: null,
	state: null,
	closedAt: null,
	firstHandledAt: null,
	firstReplyAt: null,
	priority: null,
	priorityLabel: null
});

const toDate = epoch => epoch ? new Date(parseInt(epoch) * 1000) : null;
const sinceCreated = (createdAt, at) => createdAt && at ? at - createdAt : null;

export default class SupportTicket extends SupportTicketRecord {

	number: number;
	subject: string;
	createdAt: Date;
	lastReplyAt: Date;
	customerEmail: string;
	rawDeviceIds: string;
	state: string;
	closedAt: Date;
	firstHandledAt: Date;
	firstReplyAt: Date;
	priority: number;
	priorityLabel: string;
	
	constructor(data) {
		super({
			...data,
			createdAt: toDate(data.createdAt),
			lastReplyAt: toDate(data.lastReplyAt),
			closedAt: toDate(data.closedAt),
			firstHandledAt: toDate(data.firstHandledAt),
			firstReplyAt: toDate(data.firstReplyAt),
			state: typeof data.state === 'number' ? data.state : parseInt(data.state)
		});
	}

	// KPIs, in ms since the ticket was created; null while the moment has not happened yet.
	get timeToHandle() {
		return sinceCreated(this.createdAt, this.firstHandledAt);
	}

	get timeToReply() {
		return sinceCreated(this.createdAt, this.firstReplyAt);
	}

	// The helpdesk keeps the last close timestamp after a reopen, so it only counts while closed.
	get timeToClose() {
		return this.isClosed ? sinceCreated(this.createdAt, this.closedAt) : null;
	}

	get deviceIds() {
		try {
			if (!this.rawDeviceIds) return [];
			const parsed = JSON.parse(this.rawDeviceIds);
			const arr = Array.isArray(parsed) ? parsed : [parsed];
			return arr.map(Number);
		} catch (e) {
			if (typeof this.rawDeviceIds === 'string' && this.rawDeviceIds.includes(',')) {
				return this.rawDeviceIds.split(',').map(id => Number(id.trim())).filter(id => !isNaN(id));
			}
			const num = Number(this.rawDeviceIds);
			return isNaN(num) ? [] : [num];
		}
	}

	get isOpen() {
		return SupportTicketStatus.isOpen(this.state);
	}

	get isClosed() {
		return SupportTicketStatus.isClosed(this.state);
	}

	get isActive() {
		return this.state === SupportTicketStatus.ACTIVE;
	}
}
